import React from "react";
import './index.scss'
import {ContractCheckHeader} from "../../components/ContractCheck/Header";
import {ContractCheckContent} from "../../components/ContractCheck/Content";
import {ContractCheckFooter} from "../../components/ContractCheck/Footer";

export const ContractCheckForm = () => {

    return (
        <div className={'contract-check-wrapper'}>
            <ContractCheckHeader/>
            <div className={'contract-check-wrapper__content'}>
                <ContractCheckContent/>
            </div>
            <ContractCheckFooter/>
        </div>
    )
};
